import React, { useState } from 'react'
import SmallModal from '../../component/SmallModal'
import CustomButton from '../../component/CustomButton'
import Select from 'react-select';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import './style.css'


const CompanySettingsTemplate = () => {
    const [workHourModal, setWorkHourModal] = useState(false)

    const fromHourList = [
        {value: '01', label: '01'},
        {value: '02', label: '02'},
        {value: '03', label: '03'},
        {value: '04', label: '04'},
        {value: '05', label: '05'},
        {value: '06', label: '06'},
        {value: '07', label: '07'},
        {value: '08', label: '08'},
        {value: '09', label: '09'},
        {value: '10', label: '10'}
    ]
    const untilHourList = [
        {value: '11', label: '11'},
        {value: '12', label: '12'},
        {value: '13', label: '13'},
        {value: '14', label: '14'},
        {value: '15', label: '15'},
        {value: '16', label: '16'},
        {value: '17', label: '17'},
        {value: '18', label: '18'},
        {value: '19', label: '19'},
        {value: '20', label: '20'},
        {value: '21', label: '21'},
        {value: '22', label: '22'},
        {value: '23', label: '23'},
        {value: '24', label: '24'},
    ]

    const timezoneList = [
        {value: 'UTC-02', label: '(UTC-02:00) Brazil'},
        {value: 'UTC-03', label: '(UTC-03:00) Salvador'},
        {value: 'UTC-04', label: '(UTC-03:00) United States'},

    ]
  return (
    <>
        <SmallModal 
            showModal={workHourModal} 
            title={'Working hours'}
            closeModal={() => setWorkHourModal(false)}
        >
            <div className='flex justify-center items-center space-x-4'>
                <div>
                    <div className=''>From hour</div>
                    <Select
                        className='w-52'
                        name="fromHour"
                        options={fromHourList}
                        placeholder="Select from hour..."
                        // className="basic-multi-select"
                        // classNamePrefix="select"
                    />
                </div>
                <div>
                    <div className=''>Until hour</div>
                    <Select
                        className='w-52'
                        name="fromHour"
                        options={untilHourList}
                        placeholder="Select until hour..."
                        // className="basic-multi-select"
                        // classNamePrefix="select"
                    />
                </div>
            </div>
            <div className='mt-5'>Time zone</div>
            <Select
                className='w-full'
                name="fromHour"
                options={timezoneList}
                placeholder="Select time zone..."
                // className="basic-multi-select"
                // classNamePrefix="select"
            />
        </SmallModal>
        <div className='rounded-xl border py-10 px-5'>
            <div className='text-4xl font-semibold pb-5 text-center border-b'>Company settings</div>
            <div className='lg:grid lg:grid-cols-2 mt-11 gap-20'>
                <div className='space-y-10'>
                    <div>
                        <div className='text-3xl font-semibold'>Working hours</div>
                        <p className='text-lg my-5'>Current working hours: 02 - 02 </p>
                        <CustomButton onClickButton={() => setWorkHourModal(true)} className={'!w-full justify-center'} label={'Change'} secondary/>
                    </div>
                    <div>
                        <div className='text-3xl font-semibold'> Stock settings</div>
                        <div className='flex items-center mt-5'>
                            <input  id="stock-checkbox" type="checkbox" value="" className="w-4 h-4 accent-primary700" />
                            <label for="stock-checkbox" className="ml-2 text-sm text-gray-900 ">look up product availability in the suppliers' stocks</label>
                        </div>
                    </div>
                    <div>
                        <div className='text-3xl font-semibold'>POS Settings</div>
                        <p className='text-lg my-5'>Protocol reset internal </p>

                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="monthly"
                            name="radio-buttons-group"
                            className="radio-buttons"
                        >
                            <FormControlLabel value="monthly" control={<Radio />} label={'monthly'} />
                            <FormControlLabel value="two-weeks" control={<Radio />} label={'two weeks'} />
                            <FormControlLabel value="weekly" control={<Radio />} label={'weekly'} />
                        </RadioGroup>
                    </div>
                </div>
                <div className='space-y-10'>
                    <div>
                        <div className='text-3xl font-semibold'>Administration settings</div> 
                        <p className='text-lg my-5'>Managers </p>
                        <Select
                            className='w-full'
                            name="fromHour"
                            options={timezoneList}
                            placeholder="Select manger..."
                            // className="basic-multi-select"
                            // classNamePrefix="select"
                        />
                    </div>
                    <div>
                        <div className='text-3xl font-semibold'> Invoice settings</div>
                        <div className='flex items-center mt-5'>
                            <input  id="stock-checkbox" type="checkbox" value="" className="w-4 h-4 accent-primary700" />
                            <label for="stock-checkbox" className="ml-2 text-sm text-gray-900 ">exempt without credit cf. art. 310 of the tax code</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default CompanySettingsTemplate